import MaterialAccordion, { AccordionProps } from '@mui/material/Accordion';

export function Accordion(props: AccordionProps) {
    return (
        <MaterialAccordion
            data-testid={'Accordion-container'}
            {...props}
        ></MaterialAccordion>
    );
}

export default Accordion;
